export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/src/constant.js
// module id = 1233
// module chunks = 0